import { useUIStore } from 'Modules/ui/index.store';
import { useIsSmallScreen } from './useIsSmallScreen';

/**
 * Whether the secondary menu should be shown.
 * On small screens it follows the open state; on larger screens it stays shown.
 */
export const useIsSecondaryMenuVisible = (): boolean => {
  const isSecondaryMenuOpen = useUIStore((state) => state.isSecondaryMenuOpen);
  const isSmallScreen = useIsSmallScreen();

  return !isSmallScreen || isSecondaryMenuOpen;
};
